import React from 'react';
import { Helmet } from "react-helmet";
import './hls.style';
import { Hls } from './hls';

export class Hls_Component extends React.Component {
    constructor( props ) {
        super();
    }

    render() {
        return (
            <>
                <Helmet>
                    <title>{`Здоровый образ жизни - Медицинский портал Нижегородской области: информация о врачах и учреждениях здравоохранения`}</title>
                    <meta property='og:title' content={`Здоровый образ жизни - Медицинский портал Нижегородской области: информация о врачах и учреждениях здравоохранения`} />
                    <meta name="description" content={``} />
                    <meta name="og:description" content={``} />
                </Helmet>
                <Hls />
            </>
        );
    }
}